import React, { useState } from 'react';

/**
 * Componente para gerar e compartilhar links de WhatsApp
 * 
 * @param {Object} props - Propriedades do componente
 * @param {string} props.message - Mensagem processada
 * @returns {JSX.Element} Componente React
 */
const WhatsAppLink = ({ message }) => {
  const [phone, setPhone] = useState('');
  const [copied, setCopied] = useState(false);
  const [showToast, setShowToast] = useState(false);
  
  // Gerar link para WhatsApp
  const generateWhatsAppLink = () => {
    const encodedMessage = encodeURIComponent(message);
    const baseUrl = 'https://wa.me/';
    const phoneNumber = phone.replace(/\D/g, '');
    
    return `${baseUrl}${phoneNumber ? phoneNumber + '?' : ''}text=${encodedMessage}`;
  };
  
  // Copiar link para a área de transferência
  const copyToClipboard = () => {
    const link = generateWhatsAppLink();
    navigator.clipboard.writeText(link).then(() => {
      setCopied(true);
      setShowToast(true);
      
      setTimeout(() => {
        setShowToast(false);
      }, 2000);
    });
  };
  
  // Abrir WhatsApp com a mensagem
  const openWhatsApp = () => {
    const link = generateWhatsAppLink();
    window.open(link, '_blank');
  };
  
  return (
    <div className="mt-4 space-y-4">
      <div>
        <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
          Número de WhatsApp (opcional)
        </label>
        <div className="flex">
          <input
            type="tel"
            id="phone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="(00) 00000-0000"
            inputmode="numeric"
            className="flex-1 border border-gray-300 rounded-l-md px-3 py-2 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
          <button
            onClick={copyToClipboard}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-r-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            <svg className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
            </svg>
            Copiar Link
          </button>
        </div>
        <p className="mt-1 text-xs text-gray-500">
          Se não informar um número, o cliente precisará selecionar o contato ao abrir o WhatsApp.
        </p>
      </div>
      
      <button
        onClick={openWhatsApp}
        className="w-full inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
      >
        <svg className="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
        </svg>
        Abrir no WhatsApp
      </button>
      
      {/* Toast de notificação */}
      {showToast && (
        <div className="fixed bottom-4 right-4 bg-gray-800 text-white px-4 py-2 rounded-lg shadow-lg animate-fade-in-up">
          Link copiado para a área de transferência!
        </div>
      )}
    </div>
  );
};

export default WhatsAppLink;
